<div *ngIf="!loading; else dataLoading">
  <ng-container *ngIf="!this.accessDenied && prop">
    <!-- header content -->
    <div class="header-content">
      <div class="left">
        <button
          mat-icon-button
          color="primary"
          [routerLink]="[headerContentbackLink]"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <p class="h2 center text-truncate">{{ headerContentTitle }}</p>
      <div class="right">
        <button
          *ngIf="canUpdateProperty"
          mat-icon-button
          color="primary"
          appTooltip="Autres actions"
          [matMenuTriggerFor]="menuOther"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </div>
    <div class="container-fluid content-with-float-btn">
      <app-breadcrumb
        [isSharedProperty]="isSharedProperty"
        (current)="onNewBreadcrumb($event)"
      ></app-breadcrumb>
      <app-property-photos
        *ngIf="canViewPhoto && !visitAcknowledgementRequired"
        #slideShow
        [prop]="prop"
        [slideShowOnly]="true"
      ></app-property-photos>

      <div class="top-header">
        <app-property-profil
          [prop]="prop"
          (mainPhotoClicked)="showPhotos()"
          [mainPhotoIsClickable]="canViewPhoto && !visitAcknowledgementRequired"
          mainPhotoTooltip="Voir les photos"
        ></app-property-profil>
      </div>

      <div
        *ngIf="canUpdateProperty && isCertificationRequestOnGoing"
        class="certif-request alert alert-info mt-2"
      >
        <div class="r-title">Processus de certification en cours</div>
        <div>
          <span class="r-status-title">Statut :</span>
          <span class="r-status">{{ certificationRequestStatusName }}</span>
        </div>
        <div>
          <span *ngIf="certificationRequest.message" class="r-message-title"
            >Message :</span
          >
          <span class="r-message">{{ certificationRequest.message }}</span>
        </div>
        <button
          mat-icon-button
          *ngIf="userHelper.isAdmin()"
          (click)="
            actionService.confirmDeleteCertificationRequest(
              certificationRequest
            )
          "
          color="primary"
          appTooltip="Annuler la demande"
        >
          <mat-icon aria-label="Annuler la demande">delete_forever</mat-icon>
        </button>
      </div>

      <div
        *ngIf="openDataSyncInProgress || openDataSyncDone"
        class="alert alert-success text-center"
      >
        <ng-container *ngIf="openDataSyncInProgress">
          Synchronisation des données publiques en cours... (temps moyen 2min)
        </ng-container>
        <ng-container *ngIf="openDataSyncDone">
          Synchronisation des données publiques effectuée !
          <div>
            <button mat-flat-button color="primary" (click)="reload()">
              Rafraîchir
            </button>
          </div>
        </ng-container>
      </div>

      <router-outlet
        *ngIf="!visitAcknowledgementRequired; else visitAck"
        (activate)="onActivate($event)"
      ></router-outlet>
    </div>
  </ng-container>

  <ng-template #visitAck>
    <div class="d-flex justify-content-center mt-5">
      <div class="visit-ack">
        <h2 class="text-center">Attestation valant bon de visite</h2>
        <p class="alert alert-success">
          Validation nécessaire pour pouvoir accéder aux informations du bien
        </p>
        <div class="formContainer">
          <form [formGroup]="formVisitMode">
            <div class="form-group">
              <mat-checkbox formControlName="visitChecked"
                >Je reconnais avoir accès aux informations de ce bien par le
                biais de {{ visitRealtorName }} et m'engage à ne pas effectuer
                de démarches directes ou indirectes auprès du
                propriétaire</mat-checkbox
              >
            </div>
            <div *ngIf="visitModeTypeFull" class="form-group">
              <p>
                Je reconnais avoir pris connaissance
                {{
                  docsToValidate.length > 1
                    ? "des documents suivants :"
                    : "du
                document
                suivant :"
                }}
              </p>
              <p
                class="doc-check"
                *ngFor="let doc of form_validatedDocs.controls; let i = index"
                formArrayName="validatedDocs"
                (click)="docCheckboxOnClick(i)"
              >
                <mat-checkbox [formControl]="doc"></mat-checkbox>
                <a
                  class="doc-check"
                  (click)="viewDoc(i)"
                  appTooltip="Visualiser le document pour pouvoir le cocher"
                >
                  {{ docsToValidate[i].name }} -
                  {{ docsToValidate[i].size | fileSize }}</a
                >
              </p>
              <p class="doc-info doc-warn" *ngIf="!form_validatedDocs.enabled">
                Vous devez visualiser
                {{
                  docsToValidate.length > 1
                    ? "les documents"
                    : "le
                document"
                }}
                pour pouvoir
                {{ docsToValidate.length > 1 ? "les" : "le" }} valider.
              </p>
              <p class="doc-info mt-2">
                {{
                  docsToValidate.length > 1
                    ? "Les documents resteront disponibles"
                    : "Le document
                restera
                disponible"
                }}
                dans le coffre du bien pour une consultation ultérieure.
              </p>
            </div>
            <div class="form-group text-center">
              <button
                mat-flat-button
                color="primary"
                (click)="onSubmit()"
                [disabled]="!formVisitModeValid || formSubmitting"
              >
                <ng-container *ngIf="formSubmitting; else submitText">
                  <mat-icon>
                    <mat-spinner diameter="20"> </mat-spinner>
                  </mat-icon>
                </ng-container>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #submitText
    >Accepter et accéder aux informations du bien</ng-template
  >

  <ng-container *ngIf="accessDenied">
    <div class="container-fluid text-center text-white mt-5 request">
      <h2 class="text-center">Demande d'accès aux données du bien</h2>
      <div class="photo"><mat-icon>lock_outline</mat-icon></div>
      <p>
        <button
          mat-flat-button
          color="primary"
          (click)="confirmRequestAccess()"
        >
          <mat-icon aria-label="Effectuer une demande d'accès"
            >lock_open</mat-icon
          >
          Demander l'accès
        </button>
      </p>
      <p class="mt-4">
        Chaque bien est partagé de manière individuelle et exclusive.
      </p>
      <p class="mt-4">
        Faites votre demande d'accès au propriétaire du bien en cliquant
        ci-dessous. <br />
        Vous serez notifié dés qu'elle sera acceptée.<br />
      </p>
      <!--<p class="mt-4">
      <mat-form-field>
        <mat-label>Message</mat-label>
        <textarea matInput placeholder="" type="text" [(ngModel)]="requestAccessMessage"></textarea>
      </mat-form-field>
    </p>-->
    </div>
  </ng-container>
</div>

<mat-menu #menuDoc="matMenu">
  <span class="m-3">Ajouter</span>
  <button
    *ngIf="isMobileApp"
    mat-menu-item
    (click)="actionService.uploadDoc(true)"
  >
    <mat-icon color="primary">document_scanner</mat-icon
    ><span>un scan de document</span>
  </button>
  <button mat-menu-item (click)="actionService.uploadDoc()">
    <mat-icon color="primary">description</mat-icon><span>des documents</span>
  </button>
  <button mat-menu-item (click)="actionService.uploadPhoto()">
    <mat-icon color="primary">image</mat-icon><span>des photos</span>
  </button>
  <button mat-menu-item (click)="actionService.addEvent()">
    <mat-icon color="primary">timeline</mat-icon><span>un évènement</span>
  </button>
  <button mat-menu-item (click)="actionService.addConsumptions()">
    <mat-icon color="primary">leaderboard</mat-icon
    ><span>des consommations</span>
  </button>
  <button mat-menu-item (click)="actionService.addMaintenance()">
    <mat-icon color="primary">engineering</mat-icon><span>un entretien</span>
  </button>
  <button mat-menu-item (click)="actionService.addWork()">
    <mat-icon color="primary">construction</mat-icon><span>des travaux</span>
  </button>
  <button
    *ngIf="canShowPropertyServiceBtnAdd"
    mat-menu-item
    (click)="actionService.addPropertyService()"
  >
    <mat-icon color="primary">contact_page</mat-icon
    ><span>Un service partenaire</span>
  </button>
  <button
    *ngIf="canUpdateProperty"
    mat-menu-item
    (click)="actionService.addCustomPropertyService()"
  >
    <mat-icon color="primary">contact_mail</mat-icon><span>Un service</span>
  </button>
  <button
    *ngIf="canShowPropertySaleBtnAdd"
    mat-menu-item
    (click)="actionService.addPropertySale()"
  >
    <mat-icon color="primary">real_estate_agent</mat-icon
    ><span>Un processus de vente</span>
  </button>
</mat-menu>

<mat-menu #menuOther="matMenu">
  <button *ngIf="canUpdateProperty" mat-menu-item [matMenuTriggerFor]="menuDoc">
    <mat-icon color="primary">add</mat-icon><span>Ajouter des éléments</span>
  </button>
  <button mat-menu-item (click)="showPhotos()">
    <mat-icon color="primary">photo_library</mat-icon
    ><span>Voir les photos</span>
  </button>
  <button
    *ngIf="canRequestCertification"
    mat-menu-item
    (click)="actionService.confirmCertificationRequest()"
  >
    <mat-icon color="primary">verified_user</mat-icon
    ><span>Demander la certification</span>
  </button>
  <button *ngIf="canAddShare" mat-menu-item (click)="actionService.addShare()">
    <mat-icon color="primary">share</mat-icon><span>Partager le bien</span>
  </button>
  <button
    *ngIf="canCertifyProperty"
    mat-menu-item
    (click)="actionService.certify()"
  >
    <mat-icon color="primary">{{
      prop.certified ? "update" : "check_circle_outline"
    }}</mat-icon
    ><span>{{
      prop.certified ? "Renouveler la certification" : "Certifier le bien"
    }}</span>
  </button>
  <button
    *ngIf="canTransferProperty"
    mat-menu-item
    (click)="actionService.transfertOwnership()"
  >
    <mat-icon color="primary">people_alt</mat-icon
    ><span>Transférer la propriété</span>
  </button>
  <button mat-menu-item (click)="actionService.showQrCode()">
    <mat-icon color="primary">qr_code_2</mat-icon><span>Voir le QRCode</span>
  </button>
  <button
    *ngIf="prop && prop.certified"
    mat-menu-item
    (click)="actionService.copyPropNfcUrl(prop)"
  >
    <mat-icon color="primary">content_copy</mat-icon
    ><span>Copier le lien du bien</span>
  </button>
  <button
    *ngIf="canAddDpeNumber"
    mat-menu-item
    (click)="actionService.showPropertyDpeNumberUpdate()"
  >
    <mat-icon color="primary">flash_auto</mat-icon
    ><span>Saisir le numéro de DPE</span>
  </button>
  <button
    *ngIf="canShowPropertyDataSync"
    mat-menu-item
    (click)="actionService.showPropertyDataSync()"
  >
    <mat-icon color="primary">cloud_sync</mat-icon
    ><span>Données publiques</span>
  </button>
  <button
    *ngIf="canUpdateProperty"
    mat-menu-item
    (click)="actionService.editName()"
  >
    <mat-icon color="primary">create</mat-icon
    ><span>Modifier la description</span>
  </button>
  <button
    *ngIf="canUpdatePropertyNotes"
    mat-menu-item
    (click)="actionService.editNotes()"
  >
    <mat-icon color="primary">privacy_tip</mat-icon
    ><span>Modifier les notes personnelles</span>
  </button>
  <button
    *ngIf="canArchiveProperty"
    mat-menu-item
    (click)="togglePropertyArchive()"
  >
    <mat-icon color="primary">{{
      prop.archived ? "unarchive" : "archive"
    }}</mat-icon
    ><span>{{ prop.archived ? "Désarchiver" : "Archiver" }} le bien</span>
  </button>
  <button
    *ngIf="canDeleteProperty"
    mat-menu-item
    (click)="actionService.confirmDeleteProp()"
  >
    <mat-icon color="primary">delete_forever</mat-icon
    ><span>Supprimer le bien</span>
  </button>
</mat-menu>

<ng-template #dataLoading>
  <app-data-loading></app-data-loading>
</ng-template>
